import LandingPage from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';
import SessionsPage from './pages/SessionsPage';

export default function App() {
  const pathname = window.location.pathname;
  if (pathname === '/privacy-policy') return <PrivacyPage />;
  if (pathname === '/sessions') return <SessionsPage />;
  return <LandingPage />;
}
